// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__NvY2z","subheader":"ReorderModal_subheader__2NcqZ","listWrap":"ReorderModal_listWrap__1yx2l","inactiveWrap":"ReorderModal_inactiveWrap__3ZnvF"};